import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/AttendanceRegisterOverride.api';

export const uploadAttendanceRegisterOverrideRequest = (fileData) => ({
  type: actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_REQUEST,
  payload: fileData,
});

export const uploadAttendanceRegisterOverrideSuccess = (fileData) => ({
  type: actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_SUCCESS,
  payload: fileData,
});

export const uploadAttendanceRegisterOverrideFailure = (error) => ({
  type: actionTypes.UPLOAD_ATTENDANCE_OVERRIDE_FAILURE,
  payload: error,
});

export const uploadAttendanceRegisterOverride = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadAttendanceRegisterOverrideRequest(fileData));
    try {
      const response = await api.uploadAttendanceRegisterOverride(fileData);
      dispatch(uploadAttendanceRegisterOverrideSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadAttendanceRegisterOverrideFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteAttendanceRegisterOverrideRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_REQUEST,
  payload: ids,
});

export const multiDaleteAttendanceRegisterOverrideSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_SUCCESS,
  payload: message,
});

export const multiDaleteAttendanceRegisterOverrideFailure = (error) => ({
  type: actionTypes.MULTIDELETE_ATTENDANCE_OVERRIDE_FAILURE,
  payload: error,
});

export const multiDeleteAttendanceRegisterOverrideFile = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteAttendanceRegisterOverrideRequest(ids));
    try {
      const response = await api.multiDeleteAttendanceRegisterOverride(ids);
      dispatch(multiDaleteAttendanceRegisterOverrideSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteAttendanceRegisterOverrideFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getAttendanceRegisterOverrideRequest = () => ({
  type: actionTypes.GET_ATTENDANCE_OVERRIDE_REQUEST,
});

export const getAttendanceRegisterOverrideSuccess = (data) => ({
  type: actionTypes.GET_ATTENDANCE_OVERRIDE_SUCCESS,
  payload: data,
});

export const getAttendanceRegisterOverrideFailure = (error) => ({
  type: actionTypes.GET_ATTENDANCE_OVERRIDE_FAILURE,
  payload: error,
});

export const getAttendanceRegisterOverride = (current_month) => {
  return async (dispatch) => {
    dispatch(getAttendanceRegisterOverrideRequest(current_month));
    try {
      const response = await api.fetchAttendanceRegisterOverride(current_month);
      console.log("akwfbkf", response);
      dispatch(getAttendanceRegisterOverrideSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      console.log("dJLNDd", error);
      dispatch(getAttendanceRegisterOverrideFailure(error));
      return { success: false, message: error };
    }
  };
};
